import * as React from "react";
import TabSet from "../../../hiberUiKit/src/molecules/TabSet/TabSet";
import Tab from "../../../hiberUiKit/src/atoms/Tab/Tab";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import TabSetContent from "../../../hiberUiKit/src/molecules/TabSet/TabSetContent";
import {Option} from "ts-option";
import {default as JobNoteTab} from "./JobNoteTab";
import Note from "../../../model/note/Note";
import {isNullOrUndefined} from "util";
import Job from "../../../model/job/Job";
import JobFilesTab from "./JobFilesTab";
import JobAppointmentTab from "./JobAppointmentTab";
import JobAppointment from "../../../model/appointment/job/JobAppointment";
import JobReminderTab from "./JobReminderTab";
import WarrantyInfoModal from "../warrantyInfo/modal/WarrantyInfoModal";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IProps {
	/**
	 * Job.
	 */
	job: Option<Job>;
	/**
	 * Note to edit.
	 */
	noteToEdit: Option<Note>
	/**
	 * Job appointment to edit.
	 */
	appointmentToEdit: Option<JobAppointment>;
	/**
	 * Appointment edit success.
	 */
	onAppointmentEditSuccess?: () => void;
	/**
	 * On edit success callback.
	 */
	onNoteEditSuccess?: () => void;
	/**
	 * On tab switch callback.
	 */
	onTabsSwitch?: (tabId: JobTab) => void;
	/**
	 * Initial tab.
	 */
	selectedTabId?: JobTab;
	/**
	 * Partner brand Id
	 */
	partnerBrandId: Option<string>
	/**
	 * Brand Id
	 */
	brandId: Option<string>
}

interface IState {
	/**
	 * Indicates if warranty modal is visible
	 */
	warrantyInfoModalVisible: boolean;
}

export default class JobActivityTabs extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {
			warrantyInfoModalVisible: false
		};

		this.switchTab = this.switchTab.bind(this);
		this.closeWarrantyInfoModal = this.closeWarrantyInfoModal.bind(this);
	}

	render() {
		return (
			<React.Fragment>
				<TabSet>
					<Tab icon={Icon.Note} label={"Note"} tabId={JobTab.Note}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(JobTab.Note)}/>
					<Tab icon={Icon.Reminder} label={"Reminder"} tabId={JobTab.Reminder}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(JobTab.Reminder)}/>
					<Tab icon={Icon.Appointments} label={"Appointments"} tabId={JobTab.Appointments}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(JobTab.Appointments)}/>
					<Tab icon={Icon.File} label={"File"} tabId={JobTab.Files}
						 selectedTabId={this.props.selectedTabId}
						 onClick={() => this.switchTab(JobTab.Files)}/>

					<div className={'a-tab link'}>
						<ButtonTertiary label={'Warranty info'}
										onClick={() => this.setState({warrantyInfoModalVisible: true})}/>
					</div>
				</TabSet>
				<TabSetContent isWhite={true}>
					{this.props.job.map(j => {
						switch (this.props.selectedTabId) {
							case JobTab.Note:
								return <JobNoteTab jobId={j.id}
												   noteToEdit={this.props.noteToEdit}
												   onEditSuccess={this.props.onNoteEditSuccess}/>;
							case JobTab.Reminder:
								return <JobReminderTab jobId={j.id}
													   noteToEdit={this.props.noteToEdit}
													   onEditSuccess={this.props.onNoteEditSuccess}/>;
							case JobTab.Files:
								return <JobFilesTab jobId={j.id}/>;
							case JobTab.Appointments:
								return <JobAppointmentTab jobId={j.id}
														  appointmentToEdit={this.props.appointmentToEdit}
														  onAppointmentEditSuccess={this.props.onAppointmentEditSuccess}
														  partnerBrandId={this.props.partnerBrandId}
														  brandId={this.props.brandId}/>;
							default:
								return <JobNoteTab jobId={j.id}
												   noteToEdit={this.props.noteToEdit}
												   onEditSuccess={this.props.onNoteEditSuccess}/>;
						}
					}).orNull}
				</TabSetContent>
				{this.state.warrantyInfoModalVisible &&
				<WarrantyInfoModal onSuccess={() => {}}
								   onCancel={this.closeWarrantyInfoModal}
								   job={this.props.job}/>}
			</React.Fragment>
		);
	}

	switchTab(tabId: JobTab) {
		if (!isNullOrUndefined(this.props.onTabsSwitch)) {
			this.props.onTabsSwitch(tabId);
		}
	}

	closeWarrantyInfoModal() {
		this.setState({warrantyInfoModalVisible: false});
	}
}

export enum JobTab {
	Note = "note",
	Reminder = "reminder",
	Files = "file",
	Appointments = "appointments"
}